export const SET_DADOS_COLLAPSE_RECURSOS = 'RECURSOSDISPONIVEIS/SET_DADOS_COLLAPSE'
export const LIMPAR_DADOS_COLLAPSE_RECURSOS = 'RECURSOSDISPONIVEIS/LIMPAR_DADOS_COLLAPSE'
